export type SearchHrefParams = Readonly<Record<string, string>>;

export function applySearchHrefParams(
  href: string,
  searchHrefParams?: SearchHrefParams
): string {
  if (!searchHrefParams) {
    return href;
  }

  const entries = Object.entries(searchHrefParams);
  if (entries.length === 0) {
    return href;
  }

  const resolved = new URL(href, "https://eclat.local");
  for (const [key, value] of entries) {
    if (!key || value.length === 0) continue;
    resolved.searchParams.set(key, value);
  }

  const search = resolved.searchParams.toString();
  return search ? `${resolved.pathname}?${search}` : resolved.pathname;
}
